module.exports = __webpack_public_path__ + "friend.png?12bf243dd2bfbe6dfbfb018ea3fad81d";